module.exports = __webpack_public_path__ + "img/product.9ddb484f.png";